import gql from "graphql-tag";

export const deleteProject = gql`
  mutation ($projectId: String!) {
    DeleteProject(input: { projectId: $projectId }) {
      deleted
    }
  }
`;
